import React from "react";
import { useSelector } from "react-redux";
import styles from "../GlobalEvents/GlobalEvents.module.css";
import { getAccountType } from "../../store/auth/selectors";
import {
  checkPermission,
  PERMISSION_TYPES,
} from "../../shared/utils/permissions";
import UploadButton from "../../shared/components/UploadButton/UploadButton";

const GlobalEventsHeader = ({ selectedLevel }) => {
  const accountType = useSelector(getAccountType);
  const checkUserPermission = (permissionType) =>
    checkPermission(accountType, permissionType);

  const canUploadGlobalOfflineResponse = checkUserPermission(
    PERMISSION_TYPES.UPLOAD_GLOBAL_OFFLINE_RESPONSE
  );

  return (
    <>
      <div className={styles.studentsHeading}>
        <div className={styles.studentsHeadingContent}>
          <div>
            <h3>
              Global Events &mdash;{" "}
              <span className={styles.selectedLevelSpan}>{selectedLevel}</span>
            </h3>
            <p>Manage your Student Data</p>
          </div>
          {canUploadGlobalOfflineResponse && (
            <div className={styles.globalUploadButtonWrapper}>
              <UploadButton
                uploadType="uploadOfflineResponses"
                selectedTab="Global"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GlobalEventsHeader;
